
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
const HOST = `${config.API_HOST}`
/* [] */
/* params:  */
/* data:  */
const oauth_home_view_token : 
{
  get: ({vendor, params, apiToken, extra}:
             {  vendor: any, 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  post:   ({params, data, apiToken, extra}:
            { vendor: any, 
            params?: any,
            data?: any,
            apiToken?: any,
            extra?: any
        }) => any,
} = 
{
  get: async ({vendor, params, apiToken, extra}) => {
    const base = new BaseService()
    base.client.defaults.headers.common["content-type"] = "form-data"
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/users/oauth/${vendor}/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  post: async ({vendor, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] =  "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
      
    const result = await to(base.client.post(`${HOST}/users/oauth/${vendor}/token/`,
      data,
      {
        headers: {
        "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default oauth_home_view_token

